var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Curved/Camera"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4381 12.4983C15.4381 10.7614 14.0297 9.35303 12.2928 9.35303C10.556 9.35303 9.14758 10.7614 9.14758 12.4983C9.14758 14.2351 10.556 15.6436 12.2928 15.6436C14.0297 15.6436 15.4381 14.2351 15.4381 12.4983Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2926 20.2002C20.3378 20.2002 21.2957 17.7897 21.2957 12.5665C21.2957 8.90545 20.8115 6.94651 17.7621 6.1044C17.4821 6.01598 17.1715 5.84756 16.92 5.57072C16.5136 5.12545 16.2168 3.75809 15.2357 3.3444C14.2547 2.93177 10.3147 2.95072 9.34943 3.3444C8.38522 3.73914 8.07153 5.12545 7.66522 5.57072C7.41364 5.84756 7.10417 6.01598 6.82311 6.1044C3.77364 6.94651 3.28943 8.90545 3.28943 12.5665C3.28943 17.7897 4.24732 20.2002 12.2926 20.2002Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M17.2046 9H17.2136",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.69bf751e1f63a0e841a9c65c2d0e4ccf.svg";
export { ForwardRef as ReactComponent };